const gameTypes = [{ label: 'Seasonal Mood Game', value: 'seasonal_mood' }];

export default gameTypes;
